var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.295 8.87064C28.2651 8.09221 28.2651 7.34372 28.2651 6.62517C28.2651 6.05632 27.816 5.60722 27.2471 5.60722C22.846 5.57728 19.4928 4.31982 16.7084 1.62525C16.3192 1.23604 15.6605 1.23604 15.2713 1.62525C12.4869 4.31982 9.13366 5.57728 4.76248 5.57728C4.19362 5.57728 3.74453 6.02638 3.74453 6.59523C3.74453 7.31378 3.74453 8.06227 3.71459 8.87064C3.56489 16.2657 3.35531 26.3554 15.6605 30.6068C15.7803 30.6367 15.8701 30.6667 15.9898 30.6667C16.1096 30.6667 16.2293 30.6367 16.3192 30.6068C28.6243 26.3554 28.4148 16.2657 28.295 8.87064Z",
    fill: "#E3E2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2948 8.87065C28.2649 8.09222 28.2649 7.34373 28.2649 6.62518L6.42969 23.8048C8.18715 26.5937 11.0425 29.0114 15.6603 30.6068C15.7801 30.6368 15.8699 30.6667 15.9897 30.6667C16.1094 30.6667 16.2292 30.6368 16.319 30.6068C28.6242 26.3554 28.4146 16.2657 28.2948 8.87065Z",
    fill: "#D2D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.522 12.4334L14.5819 17.3735L12.4562 15.2478C12.067 14.8586 11.4083 14.8586 10.9892 15.2478C10.6 15.637 10.6 16.2957 10.9892 16.7148L13.8334 19.5591C14.043 19.7687 14.2825 19.8585 14.552 19.8585C14.8214 19.8585 15.0909 19.7687 15.2705 19.5591L20.9591 13.8705C21.3483 13.4813 21.3483 12.8227 20.9591 12.4035C20.5699 12.0143 19.9112 12.0143 19.522 12.4334Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.e16dc049dc8c44ad25d05a02eeb59288.svg";
export { ForwardRef as ReactComponent };